module.exports = __webpack_public_path__ + "img/Kadar.02beb019.png";